<template>
    <div>
        <div class="card mb-3" id="bank">
            <div class="card-header headline bank">
                <h2 class="text-white d-inline">بانک</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 mt-5" v-if="banks === undefined || banks.length < 1">
                        <h3 class="text-center no-item-alert">حسابی ثبت نشده است!</h3>
                    </div>
                    <div class="col-lg-3 mb-3" v-for="(item, index) in banks">
                        <div class="card shadow" @click="onCardClicked(index)">
                            <div class="row p-2">
                                <div class="col-lg-12 mt-3">
                                    <h4 class="text-center">{{item.outSourceName}}</h4>
                                    <h4 class="text-center text-success">{{item.accountNumber}}</h4>
                                    <span>موجودی اولیه: </span>
                                    <span>{{item.debtor.toLocaleString()}}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--<div v-if="banks.length > 7 && lastRespond.length > 7" class="col-lg-12 text-center mb-3" @click="getBanks">
                        <button class="btn btn-success">نمایش حساب های بیشتر</button>
                    </div>-->
                    <div class="col-lg-12">
                        <div class="sk-circle" id="loadings">
                            <div class="sk-circle1 sk-child"></div>
                            <div class="sk-circle2 sk-child"></div>
                            <div class="sk-circle3 sk-child"></div>
                            <div class="sk-circle4 sk-child"></div>
                            <div class="sk-circle5 sk-child"></div>
                            <div class="sk-circle6 sk-child"></div>
                            <div class="sk-circle7 sk-child"></div>
                            <div class="sk-circle8 sk-child"></div>
                            <div class="sk-circle9 sk-child"></div>
                            <div class="sk-circle10 sk-child"></div>
                            <div class="sk-circle11 sk-child"></div>
                            <div class="sk-circle12 sk-child"></div>
                        </div>
                    </div>
                    <div v-if="!autoload && banks !== undefined && banks.length < dataCount"
                         class="col-lg-12 text-center mb-3" @click="getBanks">
                        <button class="btn btn-success">نمایش موارد بیشتر</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="bank-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="params.mode === 'create'" class="modal-title text-white">افزودن موجودی اولیه</h5>
                        <h5 v-if="params.mode === 'edit'" class="modal-title text-white">ویرایش موجودی اولیه</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 mb-2 text-center">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">موجودی اولیه</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="opening.price"
                                           @input="thousandSeprator(opening.price)">
                                </div>
                                <small class="text-nowrap mt-2">{{opening.priceshow}}</small>
                            </div>
                            <!--<div class="col-lg-6 input-group mb-2">-->
                                <!--<div class="input-group-prepend " @click="toggleStartDatePicker">-->
                                    <!--<div class="input-group-text"><span>تاریخ :</span></div>-->
                                <!--</div>-->
                                <!--<date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"-->
                                             <!--ref="datePickerStart" style="flex: 1">-->
                                    <!--<slot>-->
                                        <!--<input v-model="voucherDatePersian" class="form-control date-input" readonly="true"-->
                                               <!--@click="toggleStartDatePicker">-->
                                        <!--<button class="close reset-date" @click="resetStartDate">×</button>-->
                                    <!--</slot>-->
                                <!--</date-picker>-->
                            <!--</div>-->
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import Moment from "moment-jalali";
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'initial-bank',
        components: {DatePicker},
        data() {
            return {
                banks: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    type: 1
                },
                opening: {
                    code: "",
                    price: 0,
                    isDebtor: true,
                    voucherId: 0,
                    outsourceId: 0,
                    rowVersion: "",
                    voucherDate: "0001-01-01",
                },
                voucherDatePersian: "",
                params: {
                    mode: 'create'
                },
                searchString: "",
                dataCount: 0,

                autoload: false,
                isSending: false,
            }
        },
        mounted() {
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            new BaseService('outsource', '/getopening').getList(this.queryParams).then(response => {
                this.banks = response.data.data;
                this.dataCount = response.data.count;
                $("#loadings").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.response.message, this.$noty);
            });

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.banks.length < this.dataCount) {
                        $("#loading").show();
                        this.getBanks();
                    }
                });
            }
        },
        methods: {
            getBanks() {
                this.queryParams.pageIndex++;
                $("#loadings").show();
                new BaseService('outsource', '/getopening').getList(this.queryParams).then(response => {
                    this.banks.push.apply(this.banks, response.data.data);
                    $("#loadings").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onCardClicked(index) {
                if (this.banks[index].voucherId === 0) {
                    this.params.mode = 'create';
                    this.opening.rowVersion = this.generateUuid();
                } else {
                    this.params.mode = 'edit';
                }
                this.opening.code = this.banks[index].code;
                this.opening.price = this.banks[index].debtor;
                this.opening.voucherId = this.banks[index].voucherId;
                this.opening.outsourceId = this.banks[index].id;
                $("#bank-modal").modal("show");
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate(this.opening);
                } else {
                    this.onUpdate(this.opening);
                }
            },
            onCreate(opening) {
                if (!this.isSending) {
                    this.isSending = true;
                    new BaseService('outsource', '/opening').create(opening).then(response => {
                        this.$noty.success("موجودی اولیه با موفقیت افزوده شد.");
                        $("#bank-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('outsource', '/getopening').getList(this.queryParams).then(response => {
                            this.banks = response.data.data;
                            $("#loading").hide();
                            this.opening.code = "";
                            this.opening.price = 0;
                            this.opening.isDebtor = true;
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;

                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }
            },
            onUpdate(opening) {
                if (!this.isSending) {
                    this.isSending = true;

                    new BaseService('outsource', '/opening').update(opening).then(response => {
                        this.$noty.success("موجودی اولیه با موفقیت ویرایش شد.");
                        $("#bank-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('outsource', '/getopening').getList(this.queryParams).then(response => {
                            this.banks = response.data.data;
                            $("#loading").hide();
                            this.opening.code = "";
                            this.opening.price = 0;
                            this.opening.isDebtor = true;
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }
            },
            thousandSeprator(a) {

                let amount = a;
                let showprice = "";

                console.log(a);
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                console.log(showprice);
                this.opening.priceshow = showprice;
            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            onStartDatePicked(val) {
                this.opening.voucherDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.voucherDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetStartDate() {
                this.opening.voucherDate = "0001-01-01";
                this.voucherDatePersian = '';
            },
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#bank-modal").hasClass("show")) {
                $("#bank-modal").modal("hide");
                next(false);
            } else {
                next();
            }
        },
    }
</script>